module.exports = "<div class='loadingContainer' ng-show='isLoading'>\n    <div class='loading'>\n        {{message}}\n    </div>\n</div>\n<div class='svgContainer' >\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/views/relationshipMapGOT.html
// module id = 43
// module chunks = 0